<div class="mb-6">
  @if(filtriForm){
    <div [formGroup]="filtriForm">
      <div class="flex flex-column align-items-center sm:flex-row mb-5 pt-5">
        <div class="flex align-items-center justify-content-center mb-5 sm:mb-0">
          <div class="sm:mr-3">
            <span class="p-input-icon-left p-input-icon-right p-float-label">
              <i class="pi pi-search"></i>
              <input type="text" id="cercaIscritto" class="shadow-4" pInputText formControlName="inserimento" />
              <label for="cercaIscritto">Cerca Iscritto</label>
              <i class="pi pi-times pr-1" id="clearIcon" (click)="resetBoxRicerca()"></i>
            </span>
          </div>
        </div>
        <div class="flex bottoniStyle">
          @if(xlsSpinner){
            <div class="pr-4 pt-2">
              <i class="pi pi-spin pi-cog" style="font-size: 2rem"></i>
            </div>
          }
          @else{
            <p-button
              type="button"
              icon="pi pi-download"
              iconPos="right"
              class="mr-3"
              (click)="generaCsv()"
              pTooltip="Genera CSV"
              tooltipPosition="bottom"
              [disabled]="!role_service.isAlboOrConsultazione()"></p-button>
          }
        </div>
      </div>
      <div class="flex align-items-center justify-content-center sm:justify-content-start mb-5 flex-wrap gap-3">
        <div class="mb-3 sm:mb-0">
          <p-dropdown
            formControlName="stato"
            [showClear]="true"
            [options]="statiDropdown"
            optionLabel="nome"
            placeholder="Stato" />
        </div>
        <div class="mb-3 sm:mb-0">
          <p-dropdown
          formControlName="sezione"
          [showClear]="true"
          [options]="sezioniDropdown"
          optionLabel="nome"
          placeholder="Sezione" />
        </div>
        <div class="mb-3 sm:mb-0">
          <p-calendar
            formControlName="dataIscrizioneDal"
            dateFormat="dd/mm/yy"
            inputId="dataIscrizioneDal"
            [iconDisplay]="'input'"
            [showIcon]="true"
            placeholder="Data Iscrizione dal"
            [showClear]="true" />
        </div>
        <div class="mb-3 sm:mb-0">
          <p-calendar
            formControlName="dataIscrizioneAl"
            dateFormat="dd/mm/yy"
            inputId="dataIscrizioneAl"
            [iconDisplay]="'input'"
            [showIcon]="true"
            placeholder="Data Iscrizione al"
            [showClear]="true" />
        </div>
        <div class="mb-3 sm:mb-0">
          <p-button
            class="clearFiltri"
            size="small"
            [outlined]="true"
            icon="pi pi-filter-slash"
            (click)="clearFilters()"
            pTooltip="Pulisci Filtri"
            tooltipPosition="right" />
        </div>
      </div>
      <div class="flex justify-content-start mb-5">
        <p-paginator
          [rows]="pageSize"
          [first]="first"
          [rowsPerPageOptions]="[25, 100, 250, 500]"
          (onPageChange)="pageChange($event)"
          [totalRecords]="totaleDati"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} di {totalRecords}"
          [showPageLinks]="false" />
      </div>
    </div>
  }
  <div>
    <p-table
      #dt
      [value]="listaIscritti"
      (onLazyLoad)="ordinamento($event)"
      [customSort]="true"
      [lazy]="true"
      [sortField]="orderColumn"
      [sortOrder]="orderCustom(order)">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 4rem">
            <p-checkbox
              [ngModel]="checkAllSelezionati()"
              [binary]="true"
              (onChange)="selezioneMassiva($event)" />
          </th>
          @for(headerName of headersTabella; track $index){
            <th [pSortableColumn]="headerName === 'Stato' ? '' : rowsTabella[$index]">
              {{ headerName }}
              @if(headerName !== 'Stato'){
                <p-sortIcon [field]="rowsTabella[$index]"></p-sortIcon>
              }
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-iscritto>
        <tr>
          <td>
            <p-checkbox
              [ngModel]="checkSelezionato(iscritto)"
              [binary]="true"
              (onChange)="selezionaSingolo(iscritto, $event)" />
          </td>
          @for(item of rowsTabella; track $index){
            @if(item === 'statoIscritto'){
              <td class="font-bold" [style.color]="coloreStato(iscritto.statoIscritto)">
                {{ iscritto[item] }}
              </td>
            }
            @else{
              <td>{{ iscritto[item] }}</td>
            }
          }
        </tr>
      </ng-template>
    </p-table>
  </div>
  <p-toast position="bottom-center"></p-toast>
</div>